/* eslint-disable require-jsdoc */
import React, {useState} from 'react';
import SearchField from 'react-search-field';
import PropTypes from 'prop-types';

export default function Searchbox(props) {
  const [newSearchVal, setNewSearchVal] = useState(props.searchVal);
  const handleSubmit = (value) => {
    props.setSearchVal(value);
    props.setEventSearchSubmit(true);
    // set flag to true
  };

  const handleEraseSubmit = () => {
    props.setSearchVal('');
    setNewSearchVal(props.searchVal); 
    props.setEventSubmit(true);
  };

  const handleOnChangeSubmit = (value) => {
    props.setSearchVal(value);
    // set flag to true
  };
  return(
    <div className="hearby-powersearch-area hearby-powersearch-event">
      <div className="hearby-powersearch-title hearby-search-event-title">Search live shows</div>
      <SearchField
        placeholder="Search..."
        onEnter={handleSubmit}
        onChange={handleOnChangeSubmit}
        searchText={props.searchVal}
        className="hearby-parent-search-field"
      />
      <div className="hearby-search-event-erase">
        <button className="hearby-search-event-erase-button"
          id="clickMe"
          onClick ={handleEraseSubmit}>
          X
        </button>
      </div>
    </div>
  );
}
// Searchbox.propTypes = {
//   lat: PropTypes.number,
//   lon: PropTypes.number,

// };